import { render, staticRenderFns } from "./classLesson.vue?vue&type=template&id=19ee9dc4"
import script from "./classLesson.vue?vue&type=script&lang=js"
export * from "./classLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports